<script>
    export default {
        name: "date-picker",
        props: ['presetTimes','mode'],
        template: '<input class="form-control"/>',
        data: function(){
            return {
                dates:{
                    from: '',
                    until: ''
                }
            }
        },
        mounted: function () {
            console.log("ModeB:" + this.mode);
            var vm = this;

            var calStartRef = moment();

            if(this.presetTimes){

                this.dates.from = this.presetTimes.from;
                this.dates.until = this.presetTimes.until;

                this.startDate = this.dates.from;
                this.endDate = this.dates.until;

                calStartRef =  this.startDate;
            }else{
                const start = moment();
                const remainder = 15 - (start.minute() % 15);
                const dateTime = moment(start).add(remainder, "minutes");
                this.startDate = moment(start).add(remainder, "minutes");
                //this.endDate = dateTime.add(24, 'hour');
                this.endDate =  moment().add(1, 'week').hours(20).startOf('hour')
                this.dates.from = this.startDate;
                this.dates.until = this.endDate;

                calStartRef = moment(start).add(remainder, "minutes");
            }

            this.minDate = undefined;
            //this.start = this.startDate;
            //this.end = this.endDate;

            // Im Request-Mode nur Anfragen ausgehend vom aktuellen Datum erlauben
            if(this.mode == 'request'){
                this.minDate = moment().startOf("day");
            }



            let daysOfWeek = "";
            let monthNames = "";

            if(window.AshnetApp.currentLocale == "de"){
                monthNames = [
                    "Januar",
                    "Februar",
                    "März",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember"
                ];
                daysOfWeek = [
                    "So",
                    "Mo",
                    "Di",
                    "Mi",
                    "Do",
                    "Fr",
                    "Sa"
                ]
            }else{
                monthNames = undefined;
                daysOfWeek = undefined;
            }




            var options = {
                autoApply: true,
                showCustomRangeLabel: true,
                linkedCalendars: true,
                timePicker: AshnetApp.showRentalTime,
                timePicker24Hour: true,
                timePickerIncrement: 15,
                showISOWeekNumbers: true,
                startDate: this.startDate,
                endDate: this.endDate,
                alwaysShowCalendars: true,
                buttonClasses: "btn btn-sm",
                applyButtonClasses: "btn-primary",
                cancelClass: "btn-default",
                ranges: {
                    [vm.$t('cstrings.Heute')]: [calStartRef, moment().hours(20).startOf('hour')],
                    [vm.$t('cstrings.Bis morgen')]: [calStartRef, moment().add(1, 'days').hours(20).startOf('hour')],
                    [vm.$t('cstrings.Eine Woche')]: [calStartRef, moment().add(1, 'week').hours(20).startOf('hour')],
                    [vm.$t('cstrings.Bis über das Wochenende')]: [calStartRef, moment().add(1,'week').startOf('week').add(1,'days').hours(20).startOf('hour')],
                    [vm.$t('cstrings.Einen Monat')]: [calStartRef, moment().add(1, 'month').hours(20).startOf('hour')],
                    [vm.$t('cstrings.Ein Jahr')]: [calStartRef, moment().add(1, 'year').hours(20).startOf('hour')]
                },
                minDate: this.minDate,
                locale: {
                    format: AshnetApp.dateTimeFormat,
                    separator: " - ",
                    applyLabel: vm.$t("cstrings.Übernehmen"),
                    cancelLabel: vm.$t("cstrings.Abbrechen"),
                    fromLabel: vm.$t("cstrings.Beginn"),
                    toLabel: vm.$t("cstrings.Ende"),
                    customRangeLabel: vm.$t("cstrings.Anderer Zeitraum"),
                    weekLabel: vm.$t("cstrings.KW"),
                    daysOfWeek: daysOfWeek,
                    monthNames: monthNames,
                    "firstDay": 1
                }
            };

            if(this.mode == 'statistics'){
                options.ranges =  {
                    [vm.$t('cstrings.Aktuelles Jahr')]: [moment().startOf('year'), moment().endOf('year') ],
                    [vm.$t('cstrings.Letztes Jahr')]: [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
                };
                options.startDate = moment().startOf('year');
                options.endDate = moment().endOf('year');
            }

            this.$nextTick(()=>{
                window.$(this.$el).daterangepicker(options).on('apply.daterangepicker', function (e, picker) {
                    console.log("inner apply.daterangepicker");
                    vm.manualApplyDates(vm, picker);
                }).on('hide.daterangepicker', function (e, picker) {
                    console.log("inner hide.daterangepicker");
                    // Wenn per click outside ausgeblendet wird, muss auch applied werden, sonst wird equipment nicht neu geladen
                    vm.manualApplyDates(vm, picker);
                });
                this.fireLoadedEvent();
            });

        },
        methods: {
            manualApplyDates(vm, picker){
                vm.dates.from = picker.startDate;
                vm.dates.until = picker.endDate;
                vm.$emit('apply',  vm.dates);
                vm.startDate = vm.dates.from;
                vm.endDate = vm.dates.until;
                vm.start = vm.dates.from;
                vm.end = vm.dates.until;
            },

            fireLoadedEvent: function(){
                var vm = this;
                vm.$emit('loaded',  this.dates);
            },

            fireApplyEvent: function(){
                this.$emit('apply',  this.dates);
            },

            /**
             * Setzt den aktuellen Zeitraum des Auftrags
             * @param from Wert des Beginns
             */
            setPreselectedTiming: function(timing){
                if(timing){
                    var tmpPicker = window.$(this.$el).data('daterangepicker');
                    tmpPicker.setStartDate(window.moment(timing.from));
                    tmpPicker.setEndDate(window.moment(timing.until));

                    this.fireApplyEvent();
                }
            },

        }
    }
</script>

<style scoped>

</style>
